import { MailResourceSave, MailResourceSendTest } from 'App/resources/Model/Mail';
import Resource from './Resource';
class Mail extends Resource {
	eventName: 'mail';
	notifications: { [key: string]: () => { [key: string]: string } };

	constructor() {
		super('mail');
		this.eventName = 'mail';
		this.notifications = {
			test: () => ({
				title: 'mail.sent',
				body: 'mail.testSent',
				style: 'success',
				icon: 'check',
				type: 'body'
			}),
			testError: () => ({
				title: 'default.error',
				body: 'saveError.testMail',
				style: 'error',
				icon: 'times',
				type: 'body'
			}),
			delete: () => ({
				title: 'default.deleted',
				body: 'deleted.mail',
				style: 'success',
				icon: 'check',
				type: 'body'
			})
		};
	}

	handleData = (parser: any, res: any) => {
		return { ...res.data, data: res.data ? parser(res.data.data) : null };
	};

	save(data: MailResourceSave, opts = {}) {
		return super.save(data, opts);
	}

	findByThread(filters: any = {}, opts = {}) {
		if (filters === null || typeof filters !== 'object' || !Object.keys(filters).length) {
			filters = undefined;
		}
		return super
			._getRequest('byThread', { params: filters, ...opts })
			.then(this.handleData.bind(this, super._parse.bind(this)));
	}

	async sendTest(data: { mail: MailResourceSendTest }, opts = {}) {
		const mappedData = this._map(data);
		const res = await this._postRequest('test', mappedData, { ...opts, methodName: 'test' });
		return { ...res.data, data: this._parse.bind(this)(res.data.data) };
	}
}
export default new Mail();
